<template>
  <div class="marker bounce"/>
</template>

<script setup>

</script>

<style scoped lang="scss">
  .marker {
    background-color: red;
    border-radius: 100%;
    width: 10px;
    height: 10px;

    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    animation-delay: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .bounce {
    -webkit-animation-name: bounce;
    animation-name: bounce;
  }

  @-webkit-keyframes bounce {
    0%, 20%, 50%, 80%, 100% {-webkit-transform: translateY(0);}
    40% {-webkit-transform: translateY(-6px);}
    60% {-webkit-transform: translateY(-3px);}
  }

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
    40% {transform: translateY(-6px);}
    60% {transform: translateY(-3px);}
  }
</style>
